import { cn } from "@/lib/cn";

export function LoadingSpinner({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "inline-block h-10 w-10 rounded-full border-2 border-white/10 border-t-blurple-400 border-r-fuchsia-300 animate-spin shadow-[0_0_30px_rgba(120,133,255,0.25)]",
        className,
      )}
    />
  );
}

export function LoadingState({
  className,
  compact = false,
  label = "Loading...",
}: {
  className?: string;
  compact?: boolean;
  label?: string;
}) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-4 rounded-[28px] border border-white/10 bg-white/[0.03] text-center", compact ? "min-h-[120px] p-6" : "min-h-[220px] p-10", className)}>
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-blurple-500/15 blur-xl" />
        <LoadingSpinner className={compact ? "h-8 w-8" : "h-10 w-10"} />
      </div>
      <p className="text-sm text-slate-300">{label}</p>
    </div>
  );
}
